import { render, staticRenderFns } from "./DeactivePhdThesis.vue?vue&type=template&id=78aa127c&"
import script from "./DeactivePhdThesis.vue?vue&type=script&lang=js&"
export * from "./DeactivePhdThesis.vue?vue&type=script&lang=js&"
import style0 from "./DeactivePhdThesis.vue?vue&type=style&index=0&id=78aa127c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports